import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SPSCommerce.frontend.types'

@Injectable({ providedIn: 'root' })
export class SPSCommerce_get_order_with_optionsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { transaction_id?: string, order_lookup?: string, project_lookup?: string, shipment_id?: number, set_transmission: boolean }): Promise<{ orders?: $frontendTypes.FootprintApiManager.DatexOrderInfo[], messages?: any[], status?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.set_transmission)) {
      $missingRequiredInParams.push('\'set_transmission\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/Get/Order`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

